import { render } from "./Settings.vue?vue&type=template&id=8a434f0c"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render

export default script